const LOAD_DATA_CONTACT          = 'LOAD_DATA_CONTACT'
const LOAD_DATA_CONTACT_SUCCESS  = 'LOAD_DATA_CONTACT_SUCCESS'
const LOAD_DATA_CONTACT_FAILED   = 'LOAD_DATA_CONTACT_FAILED'
const UNMOUNT_DATA_CONTACT       = 'UNMOUNT_DATA_EMAIL'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const contactReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_CONTACT:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_CONTACT_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_CONTACT_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_CONTACT:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default contactReducer;